// Add markers to map
export const addMarkers = (type = 'sitewide', markers = []) => {

	return {
		type: 'ADD_MARKERS',
		options: {
			type,
			markers,
		}
	}
}

// Remove markers from map
export const removeMarkers = (type = 'sitewide') => {

	return {
		type: 'REMOVE_MARKERS',
		options: {
			type,
		}
	}
}

// Add polylines to map
export const addPolylines = (type = 'sitewide', polylines = []) => {
	return {
		type: 'ADD_POLYLINES',
		options: {
			type,
			polylines,
		}
	}
}

// Remove polylines from map
export const removePolylines = (type = 'sitewide') => {
	return {
		type: 'REMOVE_POLYLINES',
		options: {
			type,
		}
	}
}

// Remove polylines from map
export const hidePolylines = (polyLines = []) => {
	return {
		type: 'HIDE_POLYLINES',
		options: {
			polyLines,
		}
	}
}

// Add polygons to map
export const addPolygons = (type = 'sitewide', polygons = []) => {
	return {
		type: 'ADD_POLYGONS',
		options: {
			type,
			polygons,
		}
	}
}

// Remove polygons from map
export const removePolygons = (type = 'sitewide') => {
	return {
		type: 'REMOVE_POLYGONS',
		options: {
			type,
		}
	}
}

// Add overlays to map
export const addOverlay = (type = 'sitewide', overlays = []) => {
	return {
		type: 'ADD_OVERLAYS',
		options: {
			type,
			overlays,
		}
	}
}

// Remove overlays from map
export const removeOverlay = (type = 'sitewide') => {
	return {
		type: 'REMOVE_OVERLAYS',
		options: {
			type,
		}
	}
}

// Set user location (from geolocation)
export const setUserLocation = (lat, lng) => {
	return {
		type: 'SET_USER_LOCATION',
		options: {
			lat,
			lng,
		}
	}
}

// Clear map of all objects (markers, polylines etc) for a given type
export const clearMap = (type = 'sitewide') => {
	return {
		type: 'CLEAR_MAP',
		options: {
			type,
		}
	}
}

export const setManualBounds = (bounds = {}) => {
	return {
		type: 'SET_MANUAL_BOUNDS',
		options: {
			bounds,
		}
	}
}

export const setInStreetView = (inStreetView) => {
	return {
		type: 'SET_IN_STREET_VIEW',
		options: { inStreetView }
	}
}


// WEBPACK FOOTER //
// ./src/actions/map.js